var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33464 3.83398H16.668C17.5846 3.83398 18.3346 4.63086 18.3346 5.60482V16.2298C18.3346 17.2038 17.5846 18.0007 16.668 18.0007H3.33464C2.41797 18.0007 1.66797 17.2038 1.66797 16.2298V5.60482C1.66797 4.63086 2.41797 3.83398 3.33464 3.83398ZM10.8846 11.2184L16.3346 7.59701C16.543 7.45535 16.668 7.21628 16.668 6.95951C16.668 6.36628 16.0596 6.01212 15.5846 6.32201L10.0013 10.0319L4.41797 6.32201C3.94297 6.01212 3.33464 6.36628 3.33464 6.95951C3.33464 7.21628 3.45964 7.45535 3.66797 7.59701L9.11797 11.2184C9.65964 11.5814 10.343 11.5814 10.8846 11.2184Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.68a01b35.svg";
export { ForwardRef as ReactComponent };